(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["kmp-js-wizard"] = factory();
	else
		root["kmp-js-wizard"] = factory();
})(globalThis, () => {
return 